import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestRankingDemo from './TestRankingDemo'
import TestRankingEditorActions from './TestRankingEditorActions'
import TestRankingElement from './TestRankingElement'
import TestRankingFormBrand from './TestRankingFormBrand'
import { STYLE_FORM_SCHEMA } from './TestRankingFormStyle'
import TestRankingFormValue from './TestRankingFormValue'
import rankingIcon from './assets/test-ranking.svg'

export default genElementConfig(CONFIG_ELEMENTS.testRanking, {
  label: t('elements.testRanking.label'),
  icon: rankingIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestRankingElement,
  Demo: [TestRankingDemo],
  FormValue: TestRankingFormValue,
  FormBrand: TestRankingFormBrand,
  EditorActions: TestRankingEditorActions,
})
